/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { toggleMfaPostRequestSchema } from './toggleMfaPostRequestSchema.ts';
import { toggleMfaPostResponseSchema } from './toggleMfaPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postToggleMfa200Schema = z.lazy(() => toggleMfaPostResponseSchema);

/**
 * @description 505 response
 */
export const postToggleMfa505Schema = z.any();

export const postToggleMfaMutationRequestSchema = z.lazy(() => toggleMfaPostRequestSchema);

export const postToggleMfaMutationResponseSchema = z.lazy(() => postToggleMfa200Schema);
